import { KeyboardEvent } from 'react';

function handleArrowKeyNavigation({
  event,
  toggle,
  open,
}: {
  event: KeyboardEvent<HTMLInputElement | HTMLDivElement>;
  toggle?: () => void;
  open: boolean;
}) {
  // Get all focusable elements in the document
  const focusableElements = document.querySelectorAll(
    'input:not(:disabled), button:not(:disabled), [tabindex]:not(:disabled)'
  );
  const currentIndex = Array.prototype.indexOf.call(focusableElements, document.activeElement);

  function scrollToFocusElement(element: HTMLElement) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function focusPrev() {
    // Move focus to the previous element (simulate Shift + Tab)
    if (currentIndex === -1) return;

    const previousElement = (focusableElements[currentIndex - 1] ||
      focusableElements[focusableElements.length - 1]) as HTMLInputElement;
    previousElement.focus();
    scrollToFocusElement(previousElement);
  }

  function focusNext() {
    // Move focus to the next element (simulate Tab)
    if (currentIndex === -1) return;

    const nextElement = (focusableElements[currentIndex + 1] ||
      focusableElements[0]) as HTMLInputElement;
    nextElement.focus();
    scrollToFocusElement(nextElement);
  }

  switch (event.key) {
    case 'ArrowLeft':
      event.preventDefault();
      return focusPrev();
    case 'ArrowRight':
      event.preventDefault();
      return focusNext();
    case 'Enter': {
      event.preventDefault();
      if (!open) return toggle?.();
      return focusNext();
    }
  }
}
export default handleArrowKeyNavigation;
